module.exports = __webpack_public_path__ + "static/media/P1000-thumb-wheel.9091777d.svg";